import { useState } from 'react'
import useLocalStorage from './useLocalStorage'

type UserCoords = { lat: number; lng: number }
type UserLocationStatus = 'idle' | 'loading' | 'success' | 'error'

const useUserLocation = () => {
  const [local_user_coords, setLocalUserCoords] =
    useLocalStorage<UserCoords | null>('user_location', null)

  const [status, setStatus] = useState<UserLocationStatus>('idle')

  const getUserCoords = () => {
    return new Promise<UserCoords>((resolve, reject) => {
      if (navigator.geolocation) {
        const success = (position: any) => {
          const { latitude, longitude } = position.coords
          resolve({
            lat: latitude,
            lng: longitude
          })
          return
        }
        const error = () => {
          reject('Geolocation is not supported for this Browser/OS.')
          return
        }
        navigator.geolocation.getCurrentPosition(success, error)
      }
      if (!navigator.geolocation) {
        reject('Geolocation is not supported for this Browser/OS.')
        return
      }
    })
  }

  const getUserLocation = async () => {
    setStatus('loading')
    try {
      const coords = await getUserCoords()
      setLocalUserCoords(coords)
      setStatus('success')
    } catch (err) {
      console.error(err)
      setStatus('error')
    }
  }

  return {
    location: local_user_coords,
    getUserLocation,
    status
  }
}

export default useUserLocation
